import React, { useState } from 'react'
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Slide,
  DialogProps,
  Box,
  Typography,
} from '@mui/material'
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded'

type CommonDialogProps = {
  open: boolean
  handleClose: () => void
  handleConfirm: () => void
  contentText: string
} & DialogProps

const Transition = React.forwardRef(function Transition(
  props: any,
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />
})

const CommonDialog: React.FC<CommonDialogProps> = ({
  open,
  handleClose,
  handleConfirm,
  contentText,
  ...otherProps
}) => {
  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
      {...otherProps}
      PaperProps={{
        style: {
          background: 'var(--c-surface)',
          border: '1.5px solid var(--c-text-primary)',
          borderRadius: 'var(--radius-md)',
          minWidth: '360px',
          padding: '8px',
        }
      }}
    >
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', pt: 1, pb: 1, gap: 2 }}>
          <Box sx={{
            width: 52, height: 52, borderRadius: '50%',
            background: 'transparent',
            border: '1.5px solid var(--c-text-primary)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <WarningAmberRoundedIcon sx={{ color: 'var(--d-traiter)', fontSize: 26 }} />
          </Box>
          <Box>
            <Typography
              sx={{
                fontFamily: 'var(--font-display)',
                fontWeight: 700,
                fontSize: '16px',
                color: 'var(--c-text-primary)',
                mb: 0.5,
              }}
            >
              Confirmation
            </Typography>
            <DialogContentText
              id="alert-dialog-slide-description"
              sx={{
                color: 'var(--c-text-secondary)',
                fontFamily: 'var(--font-body)',
                fontSize: '14px',
              }}
            >
              {contentText}
            </DialogContentText>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions sx={{ gap: 1, px: 3, pb: 3, justifyContent: 'center' }}>
        <Button
          onClick={handleClose}
          sx={{
            color: 'var(--c-text-primary)',
            border: '1.5px solid var(--c-text-primary)',
            borderRadius: 'var(--radius-sm)',
            textTransform: 'none',
            fontFamily: 'var(--font-body)',
            fontWeight: 600,
            px: 3,
            '&:hover': {
              background: 'var(--c-accent-subtle)',
            },
          }}
        >
          Annuler
        </Button>
        <Button
          onClick={handleConfirm}
          sx={{
            background: 'var(--c-text-primary)',
            color: '#fff',
            border: '1.5px solid var(--c-text-primary)',
            borderRadius: 'var(--radius-sm)',
            textTransform: 'none',
            fontFamily: 'var(--font-body)',
            fontWeight: 600,
            px: 3,
            '&:hover': {
              background: '#000',
            },
          }}
        >
          Confirmer
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default CommonDialog
